import React from 'react'

import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import {
  Sheet,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet-v1'

import { useProfileDesktopView } from 'app/ProfileRevampPage/hooks/useProfileDesktopView'

type TProfileResponsiveSheetProps = {
  isOpen: boolean
  onClose: () => void
  title: React.ReactNode
  children: React.ReactNode
  autoFocus?: boolean
  className?: string
  onCloseButtonClicked?: () => void
}

export const ProfileResponsiveSheet = ({
  isOpen,
  onClose,
  title,
  children,
  autoFocus,
  className,
  onCloseButtonClicked,
}: TProfileResponsiveSheetProps) => {
  const { isDesktop } = useProfileDesktopView()
  const closeButtonHandler = onCloseButtonClicked ?? onClose

  if (isDesktop) {
    return (
      <Dialog isOpen={isOpen} onClose={onClose} size="lg">
        <DialogOverlay />
        <DialogContent className={className}>
          <DialogHeader title={title as string} />
          <DialogCloseButton onClick={closeButtonHandler} />
          {children}
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={autoFocus}
      sheetSize="auto"
    >
      <SheetOverlay />
      <SheetContent className="max-w-xl m-auto !z-[1000]">
        <SheetCloseButton onClick={closeButtonHandler} />
        <SheetTitle bold bordered>
          {title}
        </SheetTitle>
        {children}
      </SheetContent>
    </Sheet>
  )
}
